/* AppRequestStatusTooltipV2.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _7 = "._k48pni7l{font-weight:600}";
const _6 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _5 = "._19pkidpf{margin-top:0}";
const _4 = "._2hwx1b66{margin-right:var(--ds-space-050,4px)}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import CheckCircleOutlineIcon from '@atlaskit/icon/glyph/check-circle-outline';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { RequestStatus } from '@atlassian/mpac-api-client';
import { BodyNormal, BodySmall } from '@atlassian/mpac-primitives';
import { RichTooltip } from '@atlassian/mpac-ui';
import { DateUtils } from '@atlassian/mpac-utils';
import capitalize from 'lodash/capitalize';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._p12f10yc{max-width:12.8125rem}";
const TooltipContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_p12f10yc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TooltipContainer.displayName = 'TooltipContainer';
}
const Container = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const IconWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2hwx1b66 _1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  IconWrapper.displayName = 'IconWrapper';
}
const Content = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _syaz1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Content';
}
const TooltipRejectedTitle = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48pni7l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TooltipRejectedTitle.displayName = 'TooltipRejectedTitle';
}
function getOpenRequestTooltipContent(appRequestStatus, appName, showAppEditions) {
  if (showAppEditions && appRequestStatus.edition) {
    return "You requested the ".concat(capitalize(appRequestStatus.edition), " plan of ").concat(appName, " on ").concat(DateUtils.longDate(appRequestStatus.requestedDate, 'MMM dd, yyyy'));
  }
  return "You requested for the app on ".concat(DateUtils.longDate(appRequestStatus.requestedDate, 'MMM dd, yyyy'));
}
export const AppRequestStatusTooltipV2 = props => {
  let label;
  let icon;
  let tooltipContent;
  const response = props.appRequestStatus;
  if (response.status === RequestStatus.OPEN) {
    label = props.showAppEditions && response.edition ? "".concat(capitalize(response.edition), " requested") : 'App requested';
    icon = /*#__PURE__*/_jsx(CheckCircleOutlineIcon, {
      label: "",
      size: "small",
      primaryColor: "var(--ds-icon, #44546F)"
    });
    tooltipContent = /*#__PURE__*/_jsx(TooltipContainer, {
      children: /*#__PURE__*/_jsx(BodySmall, {
        children: getOpenRequestTooltipContent(response, props.appName, props.showAppEditions)
      })
    });
  } else if (response.status === RequestStatus.REJECTED) {
    label = props.showAppEditions && response.edition ? "".concat(capitalize(response.edition), " request rejected") : 'App request rejected';
    icon = /*#__PURE__*/_jsx(WarningIcon, {
      size: "small",
      label: ""
    });
    tooltipContent = /*#__PURE__*/_jsxs(TooltipContainer, {
      children: [/*#__PURE__*/_jsxs(TooltipRejectedTitle, {
        children: ["Reason for rejection as on ", DateUtils.longDate(response.rejectedDate, 'MMM dd, yyyy'), ":"]
      }), /*#__PURE__*/_jsx(BodySmall, {
        children: "\"".concat(response.rejectComment, "\"")
      })]
    });
  }
  return /*#__PURE__*/_jsx(RichTooltip, {
    content: tooltipContent,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(IconWrapper, {
        children: icon
      }), /*#__PURE__*/_jsx(Content, {
        children: label
      })]
    })
  });
};